module.exports = __webpack_public_path__ + "img/team1.8b07307a.jpg";